module.exports = __webpack_public_path__ + "img/paymenticon.70a00318.svg";